import { __assign, __extends } from "tslib";
import React from 'react';
export default function measureSize(Component) {
    var Measure = /** @class */ (function (_super) {
        __extends(Measure, _super);
        function Measure(props) {
            var _this = _super.call(this, props) || this;
            _this.state = {};
            return _this;
        }
        Measure.prototype.componentDidMount = function () {
            this.measureSize();
        };
        // TODO this can cause infinite rendering loop
        // componentDidUpdate() {
        //   this.measureSize();
        // }
        Measure.prototype.measureSize = function () {
            var node = this.rendered;
            var size = {
                width: node.offsetWidth,
                height: node.offsetHeight,
            };
            if (size.width !== this.state.width ||
                size.height !== this.state.height) {
                this.setState(size);
            }
        };
        Measure.prototype.render = function () {
            var _this = this;
            return (React.createElement(Component, __assign({ size: this.state, sizeRef: function (node) {
                    _this.rendered = node;
                } }, this.props)));
        };
        return Measure;
    }(React.Component));
    return Measure;
}
